import { useState } from "react";
import {
  Grid,
  Card,
  CardContent,
  TextField,
  Tooltip,
  IconButton,
  Radio,
  Typography,
  Divider,
  Select,
  MenuItem,
  Box,
  Checkbox,
} from "../../../../components";
import { ListagemImpressoras } from "../dialogComponents";

const ConfiguracaoImpressaoTab = ({
  configuracao,
  setConfiguracao,
  onChange,
}) => {
  const [openListaImpressoras, setOpenListaImpressoras] = useState(false);
  const [tipoImpressora, setTipoImpressora] = useState("ETIQUETA");
  const telasImpressao = [
    {
      tela: "Condicionais",
      flag: null,
      modelo: "modeloImpressaoPadraoCondicionais",
    },
    {
      tela: "Orçamentos",
      flag: "impressaoDiretaOrcamentos",
      modelo: "modeloImpressaoPadraoOrcamentos",
      confirmacao: "confirmacaoImpressaoOrcamentos"
    },
    {
      tela: "Pedidos",
      flag: "impressaoDiretaPedidos",
      modelo: "modeloImpressaoPadraoPedidos",
      confirmacao: "confirmacaoImpressaoPedidos"
    },
    {
      tela: "NF-Saída",
      flag: "impressaoDiretaNf",
      modelo: "modeloImpressaoPadraoNf",
      confirmacao: "confirmacaoImpressaoNf"
      
    },
    {
      tela: "PDV",
      flag: "impressaoDiretaPdv",
      modelo: "modeloImpressaoPadraoPdv",
      confirmacao: "confirmacaoImpressaoPdv"
    },
  ];
  const modelosImpressao = ["A4", "80MM"];

  const onChangeTipoImpressora = (open, tipo) => {
    setTipoImpressora(tipo);
    setOpenListaImpressoras(open);
  };

  const onChangeRadio = (telaImpressao, isImpressaoDireta) => {
    const configuracaoTemp = {
      ...configuracao,
      [telaImpressao?.flag]: isImpressaoDireta,
      [telaImpressao?.confirmacao]: isImpressaoDireta
    };

    if (isImpressaoDireta && configuracaoTemp[telaImpressao.modelo] === "A4") {
      configuracaoTemp[telaImpressao.modelo] = null;
    }

    setConfiguracao(configuracaoTemp);
  };

  const onChangeModeloImpressao = (telaImpressao, novoValor) => {
    const configuracaoTemp = {
      ...configuracao,
      [telaImpressao?.modelo]: novoValor,
    };

    if (novoValor === "A4" && telaImpressao.flag) {
      configuracaoTemp[telaImpressao.flag] = false;
    }

    setConfiguracao(configuracaoTemp);
  };

  const handleCheckBoxConfirmacaoImpressao = (telaImpressao, event) => {
    const configuracaoTemp = {
      ...configuracao,
      [telaImpressao?.confirmacao]: event.target.checked,
    };

    setConfiguracao(configuracaoTemp);
  };

  return (
    <Card className="p-2">
      <CardContent>
        <Box sx={{ mb: 4 }}>
          <Grid container spacing={3} alignItems="center">
            <Grid item xs={12} sm={6} md={5}>
              <Typography variant="body1" sx={{ fontWeight: 500 }}>
                IMP001 - Impressora de Etiquetas
              </Typography>
            </Grid>
            <Grid item xs={10} sm={5} md={6}>
              <TextField
                label="Impressora Etiqueta Selecionada"
                disabled
                value={configuracao?.impressoraEtiqueta || ""}
                fullWidth
              />
            </Grid>
            <Grid item xs={2} sm={1} md={1}>
              <Tooltip title="Selecionar Impressora Etiqueta">
                <IconButton
                  onClick={() =>
                    onChangeTipoImpressora(!openListaImpressoras, "ETIQUETA")
                  }
                  sx={{
                    backgroundColor: "#f5f5f5",
                    "&:hover": { backgroundColor: "#e0e0e0" },
                  }}
                >
                  <i
                    className="ph-fill ph-printer"
                    style={{ fontSize: 20 }}
                  ></i>
                </IconButton>
              </Tooltip>
            </Grid>
          </Grid>
          <Grid container spacing={3} alignItems="center" sx={{ mt: 1 }}>
            <Grid item xs={12} sm={6} md={5}>
              <Typography variant="body1" sx={{ fontWeight: 500 }}>
                IMP002 - Impressora Térmica
              </Typography>
            </Grid>
            <Grid item xs={10} sm={5} md={6}>
              <TextField
                label="Impressora Térmica Selecionada"
                disabled
                value={configuracao?.impressoraTermica || ""}
                fullWidth
              />
            </Grid>
            <Grid item xs={2} sm={1} md={1}>
              <Tooltip title="Selecionar Impressora Térmica">
                <IconButton
                  onClick={() =>
                    onChangeTipoImpressora(!openListaImpressoras, "TERMICA")
                  }
                  sx={{
                    backgroundColor: "#f5f5f5",
                    "&:hover": { backgroundColor: "#e0e0e0" },
                  }}
                >
                  <i
                    className="ph-fill ph-printer"
                    style={{ fontSize: 20 }}
                  ></i>
                </IconButton>
              </Tooltip>
            </Grid>
          </Grid>
        </Box>
        <Divider sx={{ my: 4, borderWidth: 1 }} />
        <Box>
          <Typography
            variant="h6"
            sx={{ mb: 3, fontWeight: 600, color: "#333" }}
          >
            Configurações de Impressão por Tela
          </Typography>

          <Typography variant="body2" sx={{ mb: 3, color: "#666" }}>
            IMP003 - Impressão direta impressora térmica
          </Typography>
          <Grid
            container
            spacing={2}
            sx={{
              mb: 2,
              pb: 1,
              borderBottom: "2px solid #e0e0e0",
              alignItems: "center",
            }}
          >
            <Grid item xs={12} md={4}>
              <Typography
                variant="subtitle2"
                sx={{ fontWeight: 700, color: "#555", minHeight: "3em", }}
              >
                Tela
              </Typography>
            </Grid>
            <Grid item xs={12} md={2}>
              <Typography
                variant="subtitle2"
                sx={{
                  fontWeight: 700,
                  color: "#555",
                  textAlign: { xs: "left", md: "center" },
                  minHeight: "3em",
                }}
              >
                Modelo Impressão Padrão
              </Typography>
            </Grid>
            <Grid item xs={12} md={4}>
              <Grid container spacing={1}>
                <Grid item xs={6}>
                  <Typography
                    variant="subtitle2"
                    sx={{
                      fontWeight: 700,
                      color: "#555",
                      textAlign: "center",
                      minHeight: "3em",
                    }}
                  >
                    Impressão Direta
                  </Typography>
                </Grid>
                <Grid item xs={5}>
                  <Typography
                    variant="subtitle2"
                    sx={{
                      fontWeight: 700,
                      color: "#555",
                      textAlign: "center",
                      minHeight: "3em",
                    }}
                  >
                    Preview
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
            {configuracao[telasImpressao[4].flag] &&
              <Grid item xs={12} md={2}>
                <Typography
                  variant="subtitle2"
                  sx={{
                    fontWeight: 700,
                    color: "#555",
                    textAlign: "center",
                    minHeight: "3em",
                  }}
                >
                  Exibir confirmação de Impressão
                </Typography>
              </Grid>
            }
          </Grid>
          {telasImpressao.map((telaImpressao) => (
            <Grid
              container
              spacing={2}
              key={telaImpressao.tela}
              sx={{
                mb: 2,
                pb: 2,
                borderBottom: "1px solid #f0f0f0",
                alignItems: "center",
                "&:last-child": { borderBottom: "none" },
              }}
            >
              <Grid item xs={12} md={4}>
                <Typography
                  variant="body1"
                  sx={{
                    fontWeight: 500,
                    color: "#444",
                    display: "flex",
                    alignItems: "center",
                    height: "100%",
                  }}
                >
                  {telaImpressao?.tela}
                </Typography>
              </Grid>
              <Grid item xs={12} md={2}>
                <Select
                  id={`modelo-documento-${telaImpressao.modelo}`}
                  value={configuracao?.[telaImpressao?.modelo] || ""}
                  onChange={(e) =>
                    onChangeModeloImpressao(telaImpressao, e.target.value)
                  }
                  size="small"
                >
                  {modelosImpressao.map((modelo) => (
                    <MenuItem key={modelo} value={modelo}>
                      {modelo}
                    </MenuItem>
                  ))}
                </Select>
              </Grid>
              <Grid item xs={12} md={4}>
                <Grid container spacing={1}>
                  <Grid item xs={6}>
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        height: "100%",
                        alignItems: "center",
                      }}
                    >
                      {telaImpressao.flag === null ? (
                        <Typography
                          variant="body2"
                          sx={{ fontStyle: "italic", color: "#999" }}
                        >
                          Não se aplica
                        </Typography>
                      ) : (
                        <Radio
                          checked={configuracao?.[telaImpressao.flag] === true}
                          onChange={() => onChangeRadio(telaImpressao, true)}
                          color="primary"
                          size="small"
                          name={`radio-${telaImpressao.flag}`}
                        />
                      )}
                    </Box>
                  </Grid>
                  <Grid item xs={5}>
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        height: "100%",
                        alignItems: "center",
                      }}
                    >
                      {telaImpressao.flag === null ? (
                        <Typography
                          variant="body2"
                          sx={{ fontStyle: "italic", color: "#999" }}
                        >
                          Não se aplica
                        </Typography>
                      ) : (
                        <Radio
                          checked={configuracao?.[telaImpressao.flag] !== true}
                          onChange={() => onChangeRadio(telaImpressao, false)}
                          color="primary"
                          size="small"
                          name={`radio-${telaImpressao.flag}`}
                        />
                      )}
                    </Box>
                  </Grid>
                </Grid>
              </Grid>
              {(telaImpressao.tela === "PDV" && configuracao[telaImpressao.flag]) &&
                <Grid item xs={12} md={2}>
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      height: "100%",
                      alignItems: "center",
                    }}
                  >
                    <Checkbox
                      checked={configuracao?.[telaImpressao.confirmacao] ?? false}
                      onClick={(event) => handleCheckBoxConfirmacaoImpressao(telaImpressao, event)}
                      color="primary"
                      value={configuracao?.[telaImpressao.confirmacao] ?? false}
                      name={`checkbox-${telaImpressao.confirmacao}`}
                    />
                  </Box>
                </Grid>
              }
            </Grid>
          ))}
        </Box>
      </CardContent>
      <ListagemImpressoras
        open={openListaImpressoras}
        setOpen={setOpenListaImpressoras}
        configuracao={configuracao}
        onChange={onChange}
        tipo={tipoImpressora}
      />
    </Card>
  );
};

export default ConfiguracaoImpressaoTab;
